import * as Yup from 'yup';
const validationSchema = Yup.object({
  id: Yup.number(),
  tipo_user_log: Yup.number(),
  nombre: Yup.string().required("El nombre es requerido."),
  //contrasena: Yup.string().required("La contraseña es requerida."),
  direccion: Yup.string().required("La dirreción es requerida."),
  ine: Yup.string().min(10, "El campo no debe de tener menos de 10 digitos").required("El INE es requerido."),
  tel: Yup.string().max(10, "El telefono no debe ser mayor de 10 digitos").required("El teléfono es requerido."),
  email: Yup.string().required("El correo es requerido.").email('El campo debe de tener el formato de correo'),
  tipo_usuario: Yup.number().moreThan(0).required("El tipo de usuario es requerido"),
  id_ciudad: Yup.number().moreThan(0).required("La ciudad es requerida."),
  contrasena: Yup.string().when('id', (id) => {
    if(id==0){
      return Yup.string().required("La contraseña es requerida.")
    }
  }),
  margen: Yup.number().when('tipo_user_log', {
    is: 1,
    then: Yup.number().required('El margen es requerido').typeError('El margen debe ser un número')
  }),
  importe_cola: Yup.number().when('tipo_user_log', {
    is: 1,
    then: Yup.number().required("El importe de la cola es requerido.").typeError('El importe de la cola debe ser un número')
  }),
  importe_cola2: Yup.number().when('tipo_user_log', {
    is: 1,
    then: Yup.number().required("El importe de la cola 2 es requerido.").typeError('El importe de la cola 2 debe ser un número')
  }),
  importe_premio: Yup.number().when('tipo_user_log', {
    is: 1,
    then: Yup.number().required("El importe del premio es requerido.").typeError('El importe del premio debe ser un número')
  }),
  importe_premio2: Yup.number().when('tipo_user_log', {
    is: 1,
    then: Yup.number().required("El importe del premio2 es requerido.").typeError('El importe del premio 2 debe ser un número')
  }),
  dias_credito: Yup.number().when('tipo_user_log', {
    is: 1,
    then: Yup.number().required("Los dias de credito son requeridos.").typeError('Los dias de credito debe ser un número')
  }),

});
/* 
  const validationSchema = Yup.object({
    tipo_user_log:Yup.string(),
    nombre: Yup.string().required("El nombre es requerido."),
    direccion: Yup.string().required("El nombre es requerido."),
    ine: Yup.string().min(10,"El campo no debe de tener menos de 10 digitos").required("El INE es requerido."),
    tel: Yup.string().max(10,"El telefono no debe ser mayor de 10 digitos").required("El telefono es requerido."),
    email: Yup.string().required("El correo es requerido.").email('El campo debe de tener el formato de correo'),
    tipo_usuario: Yup.number().moreThan(0).required("El tipo de usuario es requerido"),
    id_ciudad: Yup.number().moreThan(0).required("La ciudad es requerida."),
    margen:Yup.number().moreThan(0).required("El margen es requerido.").typeError('El margen debe ser un número'),
    importe_cola: Yup.number().moreThan(0).required("El importe de la cola es requerido.").typeError('El importe de la cola debe ser un número'),
    importe_premio: Yup.number().moreThan(0).required("El importe del premio es requerido.").typeError('El importe del premio debe ser un número'),
    dias_credito: Yup.number().moreThan(0).required("Los dias de credito son requeridos.").typeError('Los dias de credito debe ser un número')

  }); */

export default validationSchema;